// extracted by mini-css-extract-plugin
export default {"emote":"EmoteWallWidget_emote__NHkWU","emoteFloat":"EmoteWallWidget_emoteFloat__0uc7w"};